module.exports = __webpack_public_path__ + "static/img/game3.088e5aa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/game3.png
// module id = xSGK
// module chunks = 1